import React from 'react';
import './css/statistic.css';
import QaNavBox from '../components/QaNavbox';
import StatisticData, { StatisticItem, RangeData, LocationData } from '../components/StatisticData';

const totalEntries = StatisticData.length;
const overallTotal = StatisticData.reduce((sum, stat: StatisticItem) => {
    return sum + parseInt(stat.total.replace(/,/g, ''));
}, 0);

const bondInfo = [
    { label: "Бондын нийт дүн", value: "4,000,000,000 ₮", highlight: true },
    { label: "Хүүгийн хувь", value: "20% (жилийн)", highlight: false },
    { label: "Хүү төлөх хугацаа", value: "Хагас жил тутам", highlight: false },
    { label: "Үндсэн төлбөр", value: "Хугацааны эцэст", highlight: false },
    { label: "Бондын хугацаа", value: "1.5 жил (18 сар)", highlight: false },
    { label: "Барьцаа хөрөнгө", value: "Үл хөдлөх хөрөнгө, Түрээс", highlight: false },
];

const businessModel = [
    { name: "Түрээс", percent: 50, color: "#007bff" },
    { name: "Үйлчилгээ", percent: 20, color: "#28a745" },
    { name: "Зогсоол", percent: 15, color: "#fd7e14" },
    { name: "Бусад", percent: 15, color: "#6f42c1" },
];

const revenueSources = [
    "Авто машины дилерүүд",
    "Даатгал / Үнэлгээ / Нотариат",
    "Улсын үйлчилгээ",
    "АТҮТ (зогсоол)",
    "Дугаарын хавтан үйлдвэрлэл",
];

const keyValues = [
    {
        icon: "🏢",
        title: "Нэг цэгийн үйлчилгээ",
        desc: "Авто худалдаа, даатгал, үнэлгээ, нотариат, улсын бүртгэл — бүгдийг нэг байршилд"
    },
    {
        icon: "💰",
        title: "Тогтмол орлогын эх үүсвэр",
        desc: "Түрээс болон үйлчилгээний тогтмол орлого нь бондын хүүг найдвартай бүрдүүлнэ"
    },
    {
        icon: "🤝",
        title: "АТҮТ салбар найдвартай борлуулагч",
        desc: "Улсын байгууллагатай гэрээт хамтын ажиллагаа — тогтвортой эрэлт баталгаатай"
    },
];

const marketAnalysis = [
    "Монголд авто машины импорт жил бүр өсөж байна — хойд бүсэд эрэлт тасралтгүй нэмэгдэж байна",
    "Орхон, Булган, Хөвсгөл аймгуудыг хамарсан хойд бүсэд төвлөрсөн авто худалдааны төв одоогоор байхгүй",
    "Одоогийн зах зээл: задгай талбай, үйлчилгээ салангид, итгэлцэл болон баталгаа бага",
    "Эрдэнэт хот — хойд бүсийн эдийн засгийн төв, өндөр худалдан авах чадвар бүхий зах зээл",
];

const phases = [
    { num: "01", title: "Барилга", status: "60% дууссан", color: "#28a745" },
    { num: "02", title: "Дотоод засал", status: "Хийгдэж байгаа", color: "#007bff" },
    { num: "03", title: "Түрээслэгч татах", status: "50% гэрээ байгуулсан", color: "#fd7e14" },
    { num: "04", title: "Нээлт", status: "Төлөвлөгөөт", color: "#9b59b6" },
];

const financialProjections = [
    { label: "Жилийн орлого (бага)", year1: "480,000,000 ₮", year2: "600,000,000 ₮", year3: "720,000,000 ₮" },
    { label: "Жилийн орлого (дунд)", year1: "600,000,000 ₮", year2: "780,000,000 ₮", year3: "960,000,000 ₮" },
    { label: "Жилийн орлого (өндөр)", year1: "720,000,000 ₮", year2: "960,000,000 ₮", year3: "1,200,000,000 ₮" },
    { label: "Бондын хүүгийн төлбөр", year1: "400,000,000 ₮", year2: "400,000,000 ₮", year3: "400,000,000 ₮" },
];

const investmentHighlights = [
    "Барилга 60% бэлэн — хөрөнгө оруулалтын эрсдэл бага",
    "Хойд бүсийн зах зээлд ижил төстэй өрсөлдөгч байхгүй",
    "Олон эх үүсвэрт орлого — түрээс, үйлчилгээ, зогсоол, улсын гэрээ",
    "Үл хөдлөх хөрөнгөөр баталгаажсан (asset-backed) бонд",
    "АТҮТ-тэй гэрээт хамтын ажиллагаа — тогтвортой суурь орлого",
];

const conclusionPoints = [
    "Үл хөдлөх хөрөнгийн asset-backed бонд — өндөр аюулгүй байдал",
    "Тогтвортой мөнгөн урсгалтай, олон эх үүсвэрт бизнес загвар",
    "Хойд бүсийн стратегийн байршилд баригдаж буй цорын ганц авто цогцолбор",
    "20% жилийн хүү — зах зээлийн дээд хэмжээний өгөөж",
];

const Statistic: React.FC = () => {

    return (
        <div className="statistic-page-container">
            <QaNavBox />
            <div className="statistic-content-area">

                {/* Bond Info Section */}
                <div className="bond-section-header">
                    <div className="bond-section-title">
                        <div className="bond-tag">Бондын мэдээлэл</div>
                        <h2>Хойд Бүсийн Авто Худалдааны Төв</h2>
                        <p className="bond-issuer">Чингисийн Чулуу ХХК · Орхон аймаг, Эрдэнэт хот, Говил баг</p>
                    </div>
                </div>

                <div className="bond-info-grid">
                    {/* Bond Table */}
                    <div className="bond-card">
                        <h3 className="bond-card-title">Бондын үндсэн нөхцөл</h3>
                        <div className="bond-table">
                            {bondInfo.map((row, i) => (
                                <div key={i} className={`bond-row ${row.highlight ? 'bond-row-highlight' : ''}`}>
                                    <span className="bond-label">{row.label}</span>
                                    <span className="bond-value">{row.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Project Overview */}
                    <div className="bond-card">
                        <h3 className="bond-card-title">Төслийн танилцуулга</h3>
                        <div className="project-overview">
                            <div className="project-stat-row">
                                <div className="project-stat-item">
                                    <span className="project-stat-value">3.5 га</span>
                                    <span className="project-stat-label">Газрын талбай</span>
                                </div>
                                <div className="project-stat-item">
                                    <span className="project-stat-value">20,000 м²</span>
                                    <span className="project-stat-label">Барилгын талбай</span>
                                </div>
                                <div className="project-stat-item">
                                    <span className="project-stat-value">60%</span>
                                    <span className="project-stat-label">Барилгын явц</span>
                                </div>
                            </div>
                            <div className="progress-section">
                                <div className="progress-label-row">
                                    <span>Барилгын явц</span>
                                    <span>60%</span>
                                </div>
                                <div className="progress-track">
                                    <div className="progress-fill" style={{ width: '60%' }}></div>
                                </div>
                            </div>
                            <div className="revenue-sources">
                                <h4>Орлогын эх үүсвэр</h4>
                                <ul>
                                    {revenueSources.map((src, i) => (
                                        <li key={i}>{src}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Business Model */}
                    <div className="bond-card bond-card-wide">
                        <h3 className="bond-card-title">Бизнесийн загвар</h3>
                        <div className="business-model-grid">
                            {businessModel.map((item, i) => (
                                <div key={i} className="bm-item">
                                    <div className="bm-bar-wrap">
                                        <div
                                            className="bm-bar"
                                            style={{ height: `${item.percent * 2}px`, background: item.color }}
                                        ></div>
                                    </div>
                                    <span className="bm-percent" style={{ color: item.color }}>{item.percent}%</span>
                                    <span className="bm-name">{item.name}</span>
                                </div>
                            ))}
                        </div>
                        <div className="bm-legend">
                            {businessModel.map((item, i) => (
                                <div key={i} className="bm-legend-item">
                                    <span className="bm-dot" style={{ background: item.color }}></span>
                                    <span>{item.name} — {item.percent}%</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Key Values */}
                <div className="info-section">
                    <div className="info-section-header">
                        <div className="bond-tag">Гол үнэ цэнэ</div>
                        <h2>Яагаад энэ төсөлд хөрөнгө оруулах вэ?</h2>
                    </div>
                    <div className="key-values-grid">
                        {keyValues.map((kv, i) => (
                            <div key={i} className="kv-card">
                                <span className="kv-icon">{kv.icon}</span>
                                <h4 className="kv-title">{kv.title}</h4>
                                <p className="kv-desc">{kv.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Market Analysis */}
                <div className="info-section info-section-alt">
                    <div className="info-section-header">
                        <div className="bond-tag bond-tag-green">Зах зээлийн шинжилгээ</div>
                        <h2>Зах зээлийн боломж</h2>
                    </div>
                    <div className="market-list">
                        {marketAnalysis.map((item, i) => (
                            <div key={i} className="market-item">
                                <span className="market-bullet">▶</span>
                                <span>{item}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Implementation Phases */}
                <div className="info-section">
                    <div className="info-section-header">
                        <div className="bond-tag bond-tag-orange">Төслийн хэрэгжилтийн төлөв</div>
                        <h2>Хэрэгжилтийн үе шатууд</h2>
                    </div>
                    <div className="phases-row">
                        {phases.map((phase, i) => (
                            <div key={i} className="phase-item">
                                <div className="phase-num" style={{ background: phase.color }}>{phase.num}</div>
                                <div className="phase-connector" style={{ background: i < phases.length - 1 ? '#ddd' : 'transparent' }}></div>
                                <h4 className="phase-title">{phase.title}</h4>
                                <span className="phase-status" style={{ color: phase.color }}>{phase.status}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Financial Projections */}
                <div className="info-section info-section-alt">
                    <div className="info-section-header">
                        <div className="bond-tag bond-tag-purple">Санхүүгийн төсөөлөл</div>
                        <h2>3 жилийн санхүүгийн тооцоо</h2>
                    </div>
                    <div className="fin-table-wrap">
                        <table className="fin-table">
                            <thead>
                                <tr>
                                    <th>Үзүүлэлт</th>
                                    <th>1-р жил</th>
                                    <th>2-р жил</th>
                                    <th>3-р жил</th>
                                </tr>
                            </thead>
                            <tbody>
                                {financialProjections.map((row, i) => (
                                    <tr key={i} className={i === financialProjections.length - 1 ? 'fin-row-highlight' : ''}>
                                        <td>{row.label}</td>
                                        <td>{row.year1}</td>
                                        <td>{row.year2}</td>
                                        <td>{row.year3}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Investment Highlights */}
                <div className="info-section">
                    <div className="info-section-header">
                        <div className="bond-tag">Давуу тал</div>
                        <h2>Хөрөнгө оруулалтын давуу талууд</h2>
                    </div>
                    <div className="highlights-grid">
                        {investmentHighlights.map((item, i) => (
                            <div key={i} className="highlight-item">
                                <span className="highlight-check">✓</span>
                                <span>{item}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Conclusion */}
                <div className="info-section info-section-conclusion">
                    <div className="info-section-header">
                        <div className="bond-tag bond-tag-green">Дүгнэлт</div>
                        <h2>Хөрөнгө оруулагчдад хандсан дүгнэлт</h2>
                    </div>
                    <div className="conclusion-list">
                        {conclusionPoints.map((point, i) => (
                            <div key={i} className="conclusion-item">
                                <span className="conclusion-num">{i + 1}</span>
                                <span>{point}</span>
                            </div>
                        ))}
                    </div>
                    <div className="conclusion-cta">
                        <p>Дэлгэрэнгүй мэдээлэл авах болон бондын санал авахыг хүсвэл брокертой холбогдоно уу.</p>
                    </div>
                </div>

                {/* Divider */}
                <div className="section-divider">
                    <span>Замын хөдөлгөөний статистик</span>
                </div>

                {/* Visual Header with Stats */}
                <div className="statistic-visual-header">
                    <div className="header-main">
                        <div className="title-section">
                            <h1>📊 Машины зорчих статистик</h1>
                            <p>Төрөл бүрийн газар нутагт зорчих машины тооны мэдээлэл</p>
                        </div>
                        <div className="header-stats">
                            <div className="stat-badge">
                                <span className="stat-number">{totalEntries}</span>
                                <span className="stat-label">Статистик</span>
                            </div>
                            <div className="stat-badge primary">
                                <span className="stat-number">{overallTotal.toLocaleString()}</span>
                                <span className="stat-label">Нийт зорчигч</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Statistics Grid */}
                <div className="statistic-grid">
                    {StatisticData.map((statistic: StatisticItem, index: number) => (
                        <StatisticCard
                            key={statistic.id}
                            {...statistic}
                            index={index}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

interface StatisticCardProps extends Omit<StatisticItem, 'id'> {
    id: string;
    index: number;
}

const StatisticCard: React.FC<StatisticCardProps> = ({
    title,
    location,
    type,
    data,
    total,
    year,
    index
}) => {
    const getTypeColor = () => {
        switch (type) {
            case 'range': return '#e74c3c';
            case 'location': return '#007bff';
            default: return '#9b59b6';
        }
    };

    const getTypeGradient = () => {
        switch (type) {
            case 'range': return 'linear-gradient(135deg, #e74c3c, #c0392b)';
            case 'location': return 'linear-gradient(135deg, #007bff, #0056b3)';
            default: return 'linear-gradient(135deg, #9b59b6, #8e44ad)';
        }
    };
    const renderDataPreview = () => {
        switch (type) {
            case 'range':
                const rangeData = data as RangeData[];
                const rangeTotal = rangeData.reduce((sum, item) => sum + item.AverageMonth, 0);

                return (
                    <div className="data-preview">
                        <div className="preview-stats">
                            <div className="preview-stat">
                                <span className="stat-value">{rangeData.length}</span>
                                <span className="stat-label">сар</span>
                            </div>
                            <div className="preview-stat">
                                <span className="stat-value">{(rangeTotal / rangeData.length).toLocaleString()}</span>
                                <span className="stat-label">дундаж/сар</span>
                            </div>
                        </div>
                        <div className="range-display">
                            {rangeData.map((item, i) => (
                                <div key={i} className="range-item">
                                    <span className="range-month">{item.month}</span>
                                    <span className="range-value">{item.MonthlyRange}</span>
                                    <span className="range-total">{item.AverageMonth.toLocaleString()}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                );

            case 'location':
                const locationData = data as LocationData[];

                return (
                    <div className="data-preview">
                        <div className="preview-stats">
                            <div className="preview-stat">
                                <span className="stat-value">{locationData.length}</span>
                                <span className="stat-label">байршил</span>
                            </div>
                        </div>
                        <div className="location-display">
                            {locationData.map((item, i) => (
                                <div key={i} className="location-item">
                                    <span className="location-name">{item.location}</span>
                                    <span className="location-value">{item.MonthlyRange}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div
            className="statistic-card"
            style={{
                '--type-color': getTypeColor(),
                '--type-gradient': getTypeGradient(),
                '--animation-delay': `${index * 0.1}s`
            } as React.CSSProperties}
        >
            <div className="card-glow"></div>

            <div className="card-content">
                <div className="card-title-section">
                    <h3 className="card-title">{title}</h3>
                    <div className="location-year">
                        <span className="location">
                            <span className="location-icon">📍</span>
                            {location}
                        </span>
                        <span className="year-badge">{year} он</span>
                    </div>
                </div>
                {renderDataPreview()}
            </div>

            <div className="card-footer">
                <div className="total-display">
                    <span className="total-label">Жилийн нийт зорчигч</span>
                    <span className="total-value">{total}</span>
                </div>
            </div>
        </div>
    );
};

export default Statistic;